import { useContext, useMemo } from "react";
import Select from "../selects/Select";
import TypesContext from "../../contexts/types";

const MIN_YEAR = new Date().getFullYear() - 1;
const MAX_YEAR = MIN_YEAR + 5;
const years = [];
for (let i = MIN_YEAR; i <= MAX_YEAR; i++) years.push({ label: i, value: i });

const MonthInput = props => {
  const { value, setValue, label, error } = props;
  const [year = "", month = ""] = value?.split("-") || [];
  const { months } = useContext(TypesContext);

  const selectedMonth = useMemo(
    () => months.find(item => item.value === parseInt(month) - 1),
    [month]
  );

  const onChangeYear = ({ value }) => {
    setValue(`${value}-${month}`);
  };

  const onChangeMonth = ({ value }) => {
    setValue(`${year}-${formatMonth(value + 1)}`);
  };

  return (
    <div className="monthInput">
      <label className="monthInput_label">{label}</label>
      <Select
        label="Month"
        required
        selected={selectedMonth}
        setSelected={onChangeMonth}
        width="200px"
        placeholder="Month"
        options={months}
        error={error}
      />
      <Select
        label="Year"
        required
        selected={year && { value: year, label: year }}
        setSelected={onChangeYear}
        width="200px"
        placeholder="Year"
        options={years}
        error={error}
      />
    </div>
  );
};

const formatMonth = month => {
  if (month < 10) return `0${month}`;
  else return month;
};

export default MonthInput;
